var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _circle, _path99, _path100, _g, _path101, _path102, _g2, _path103, _path104, _g3, _path105, _path106, _g4, _path107, _path108, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.333 34.797L92.776 10.051C86.931 6.29202 79.36 7.82702 75.228 13.61L47.944 51.703M47.944 51.703L25.564 83.031L25.427 83.239L25.215 83.572C25.285 83.459 25.351 83.346 25.422 83.239L10.889 103.634C5.307 111.445 5.779 122.384 12.013 129.618C25.617 145.443 48.802 172.32 60.956 186.308C63.442 189.139 66.718 191.045 70.301 191.746C71.9722 192.023 73.6732 192.074 75.358 191.897C75.772 191.841 76.186 191.778 76.594 191.696C80.689 190.877 84.349 188.465 86.862 184.931L96.071 172.011C103.621 161.373 117.53 158.553 128.234 165.492L141.246 173.904C144.816 176.223 149.075 177.035 153.181 176.18C153.595 176.098 153.997 175.997 154.4 175.884L159.054 173.759C162.144 171.707 164.532 168.655 165.868 165.052C172.321 147.285 184.552 113.234 191.744 93.191C195.033 84.025 191.684 73.67 183.789 68.59L163.236 55.343C163.802 55.755 164.345 56.203 164.862 56.683C164.333 56.1913 163.772 55.7353 163.183 55.318H163.236L162.988 55.148L131.327 34.778",
    fill: "#21AAE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 187.608C6 187.608 6.962 185.086 19.235 184.407C31.507 183.728 42.92 178.288 63.16 179.078C83.4 179.868 100.194 184.821 123.233 183.304C146.272 181.786 160.698 183.721 165.866 185.247C171.034 186.772 192.42 184.889 194 187.684L6 187.608Z",
    fill: "#A8D29F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 187.483C6 187.483 6.962 190.005 19.235 190.684C31.507 191.363 42.92 196.802 63.16 196.013C83.4 195.223 100.194 190.27 123.233 191.787C146.272 193.305 160.698 191.37 165.866 189.844C171.034 188.319 192.42 190.202 194 187.406L6 187.483Z",
    fill: "#A8D29F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.199 38H132.53C131.797 38.0065 131.072 38.1574 130.398 38.4441C129.723 38.7308 129.111 39.1476 128.598 39.6707C128.084 40.1938 127.679 40.813 127.405 41.4929C127.131 42.1727 126.993 42.9 127 43.633V156.142C126.988 157.622 127.563 159.046 128.6 160.102C129.637 161.159 131.05 161.76 132.53 161.776H187.199C188.68 161.762 190.095 161.161 191.133 160.105C192.171 159.048 192.747 157.623 192.735 156.142V43.633C192.748 42.1519 192.172 40.7264 191.134 39.67C190.095 38.6137 188.68 38.0129 187.199 38ZM189.273 152.664C189.273 155.625 187.055 158.024 184.32 158.024H135.412C132.67 158.024 130.452 155.625 130.452 152.664V47.909C130.452 41.876 132.67 41.572 135.412 41.572H145.208C145.778 41.572 146.242 42.219 146.242 43.02V43.353C146.242 45.231 147.272 45.238 148.533 45.238H171.189C172.464 45.238 173.484 45.238 173.484 43.353V43.02C173.484 42.22 173.944 41.572 174.521 41.572H184.314C187.049 41.572 189.267 42.376 189.267 47.909L189.273 152.664Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 47.91V152.664C189.261 155.626 187.043 158.024 184.308 158.024H135.413C132.671 158.024 130.453 155.626 130.453 152.664V47.909C130.453 41.876 132.671 41.572 135.413 41.572H145.208C145.779 41.572 146.242 42.219 146.242 43.02V43.353C146.242 45.231 147.273 45.238 148.534 45.238H171.19C172.464 45.238 173.485 45.238 173.485 43.353V43.02C173.485 42.22 173.945 41.572 174.522 41.572H184.315C187.043 41.572 189.261 42.373 189.261 47.91Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.501 43.923C143.471 43.953 143.437 43.983 143.407 44.017L143.354 44.07C143.112 43.8282 142.784 43.6924 142.442 43.6924C142.1 43.6924 141.772 43.8282 141.53 44.07L141.476 44.017L141.383 43.923L141.5 43.82C141.686 43.669 141.907 43.566 142.143 43.52C142.207 43.52 142.267 43.503 142.327 43.493H142.627C142.741 43.508 142.853 43.536 142.96 43.577C143.039 43.605 143.115 43.64 143.187 43.68C143.263 43.725 143.336 43.777 143.404 43.834L143.504 43.924L143.501 43.923Z",
    fill: "#C7C7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.83 44.367L141.68 44.22C141.78 44.1194 141.898 44.0395 142.029 43.9849C142.16 43.9303 142.3 43.902 142.441 43.9017C142.583 43.9015 142.723 43.9292 142.854 43.9833C142.985 44.0374 143.104 44.1168 143.204 44.217L143.054 44.367C142.891 44.2053 142.671 44.1145 142.442 44.1145C142.213 44.1145 141.993 44.2053 141.83 44.367Z",
    fill: "#C7C7C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.908 44.517L142.758 44.667C142.718 44.6248 142.669 44.5914 142.615 44.5691C142.561 44.5467 142.503 44.5358 142.445 44.537C142.387 44.5359 142.328 44.5468 142.274 44.5692C142.22 44.5916 142.172 44.6249 142.131 44.667L141.984 44.517C142.109 44.3984 142.274 44.3323 142.446 44.3323C142.618 44.3323 142.783 44.3984 142.908 44.517Z",
    fill: "#C7C7C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.594 44.8C142.594 44.8273 142.587 44.8541 142.572 44.8772C142.558 44.9003 142.537 44.9187 142.512 44.93C142.487 44.941 142.459 44.9442 142.433 44.9392C142.406 44.9342 142.381 44.9212 142.362 44.902C142.342 44.883 142.329 44.8586 142.323 44.8319C142.317 44.8051 142.32 44.7773 142.33 44.752C142.344 44.7186 142.371 44.692 142.404 44.6778C142.438 44.6636 142.475 44.663 142.509 44.676C142.526 44.6828 142.541 44.693 142.554 44.706C142.579 44.7316 142.593 44.7644 142.594 44.8ZM134.289 44.207C134.286 44.1542 134.294 44.1014 134.313 44.0518C134.331 44.0022 134.359 43.9568 134.396 43.9185C134.432 43.8802 134.476 43.8497 134.525 43.8288C134.573 43.808 134.626 43.7972 134.678 43.7972C134.731 43.7972 134.784 43.808 134.832 43.8288C134.881 43.8497 134.925 43.8802 134.961 43.9185C134.998 43.9568 135.026 44.0022 135.044 44.0518C135.063 44.1014 135.071 44.1542 135.068 44.207C135.063 44.3069 135.02 44.401 134.947 44.4699C134.875 44.5388 134.779 44.5772 134.678 44.5772C134.578 44.5772 134.482 44.5388 134.41 44.4699C134.337 44.401 134.294 44.3069 134.289 44.207ZM135.508 44.207C135.505 44.1542 135.513 44.1014 135.532 44.0518C135.55 44.0022 135.578 43.9568 135.615 43.9185C135.651 43.8802 135.695 43.8497 135.744 43.8288C135.792 43.808 135.845 43.7972 135.898 43.7972C135.95 43.7972 136.003 43.808 136.051 43.8288C136.1 43.8497 136.144 43.8802 136.18 43.9185C136.217 43.9568 136.245 44.0022 136.263 44.0518C136.282 44.1014 136.29 44.1542 136.287 44.207C136.282 44.3069 136.239 44.401 136.166 44.4699C136.094 44.5388 135.998 44.5772 135.898 44.5772C135.797 44.5772 135.701 44.5388 135.629 44.4699C135.556 44.401 135.513 44.3069 135.508 44.207ZM136.734 44.207C136.731 44.1542 136.739 44.1014 136.758 44.0518C136.776 44.0022 136.804 43.9568 136.841 43.9185C136.877 43.8802 136.921 43.8497 136.97 43.8288C137.018 43.808 137.071 43.7972 137.124 43.7972C137.176 43.7972 137.229 43.808 137.277 43.8288C137.326 43.8497 137.37 43.8802 137.406 43.9185C137.443 43.9568 137.471 44.0022 137.489 44.0518C137.508 44.1014 137.516 44.1542 137.513 44.207C137.508 44.3069 137.465 44.401 137.392 44.4699C137.32 44.5388 137.224 44.5772 137.124 44.5772C137.023 44.5772 136.927 44.5388 136.855 44.4699C136.782 44.401 136.739 44.3069 136.734 44.207ZM137.969 44.207C137.969 44.1033 138.01 44.0038 138.084 43.9305C138.157 43.8572 138.256 43.816 138.36 43.816C138.464 43.816 138.563 43.8572 138.636 43.9305C138.71 44.0038 138.751 44.1033 138.751 44.207C138.751 44.3107 138.71 44.4101 138.636 44.4834C138.563 44.5568 138.464 44.598 138.36 44.598C138.256 44.598 138.157 44.5568 138.084 44.4834C138.01 44.4101 137.969 44.3107 137.969 44.207ZM139.195 44.207C139.195 44.1033 139.236 44.0038 139.31 43.9305C139.383 43.8572 139.482 43.816 139.586 43.816C139.69 43.816 139.789 43.8572 139.862 43.9305C139.936 44.0038 139.977 44.1033 139.977 44.207C139.977 44.3107 139.936 44.4101 139.862 44.4834C139.789 44.5568 139.69 44.598 139.586 44.598C139.482 44.598 139.383 44.5568 139.31 44.4834C139.236 44.4101 139.195 44.3107 139.195 44.207ZM184.859 45.06H181.688V43.59H184.859V45.06ZM181.858 44.897H184.709V43.75H181.858V44.897Z",
    fill: "#C7C7C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.99 43.84H181.945V44.81H183.99V43.84ZM185.135 43.93H184.852V44.717H185.135V43.93Z",
    fill: "#C7C7C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.943 42.906H156.766C156.665 42.9054 156.567 42.8649 156.496 42.7932C156.424 42.7215 156.384 42.6244 156.383 42.523C156.384 42.4219 156.424 42.3252 156.496 42.2541C156.568 42.1829 156.665 42.143 156.766 42.143H162.943C162.995 42.1403 163.046 42.1482 163.095 42.1662C163.144 42.1842 163.188 42.2118 163.226 42.2475C163.263 42.2832 163.293 42.3262 163.314 42.3738C163.334 42.4214 163.345 42.4726 163.345 42.5245C163.345 42.5763 163.334 42.6275 163.314 42.6751C163.293 42.7227 163.263 42.7657 163.226 42.8014C163.188 42.8371 163.144 42.8647 163.095 42.8827C163.046 42.9007 162.995 42.9086 162.943 42.906Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.094 151.857H137.807V153.177H137.267V152.507H136.316V153.177H135.779V151.857H135.492L136.793 150.512L138.094 151.857ZM184.682 150.512H181.547V150.959H184.682V150.512ZM184.682 151.623H181.547V152.07H184.682V151.623ZM184.682 152.73H181.547V153.177H184.682V152.73ZM161.011 151.893L160.12 152.844L159.227 151.893L159.387 151.743L160.12 152.527L160.854 151.743L161.011 151.893Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.132 153.828C159.731 153.827 159.344 153.677 159.046 153.407C158.749 153.137 158.562 152.767 158.523 152.367C158.483 151.968 158.592 151.568 158.83 151.244C159.068 150.921 159.418 150.698 159.811 150.617C160.046 150.571 160.289 150.577 160.521 150.635C160.754 150.693 160.97 150.802 161.156 150.954C161.341 151.106 161.491 151.298 161.593 151.514C161.696 151.731 161.75 151.967 161.75 152.207C161.749 152.636 161.578 153.047 161.275 153.351C160.972 153.654 160.561 153.826 160.132 153.828ZM160.132 150.803C159.889 150.803 159.65 150.866 159.439 150.985C159.227 151.105 159.05 151.277 158.925 151.485C158.8 151.694 158.731 151.931 158.725 152.174C158.719 152.417 158.776 152.657 158.891 152.871C159.005 153.086 159.173 153.267 159.378 153.397C159.584 153.527 159.819 153.601 160.062 153.613C160.304 153.625 160.546 153.574 160.763 153.465C160.98 153.356 161.165 153.192 161.3 152.99C161.44 152.778 161.521 152.532 161.533 152.279C161.545 152.025 161.488 151.772 161.368 151.548C161.248 151.324 161.07 151.137 160.853 151.005C160.635 150.874 160.386 150.804 160.132 150.803Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.154 49.377H133.57V64.726H186.154V49.377Z",
    fill: "#FB6A1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.558 54.31L134.82 52.679L136.558 51.051L136.828 51.338L135.397 52.678L136.828 54.019L136.558 54.309V54.31ZM184.894 51.665C184.894 51.731 184.875 51.7956 184.838 51.8504C184.801 51.9053 184.749 51.948 184.688 51.973C184.622 52.0005 184.549 52.0059 184.479 51.9885C184.409 51.9711 184.347 51.9318 184.302 51.8764C184.256 51.821 184.23 51.7524 184.226 51.6809C184.223 51.6093 184.243 51.5384 184.282 51.4788C184.322 51.4193 184.38 51.3741 184.448 51.35C184.515 51.3259 184.589 51.3241 184.657 51.345C184.726 51.3659 184.786 51.4083 184.829 51.4659C184.871 51.5235 184.894 51.5933 184.894 51.665ZM184.894 52.882C184.894 52.948 184.874 53.012 184.837 53.067C184.801 53.1224 184.749 53.1656 184.688 53.1909C184.627 53.2162 184.56 53.2226 184.495 53.209C184.433 53.1967 184.376 53.167 184.33 53.1234C184.284 53.0797 184.251 53.0239 184.236 52.9625C184.221 52.9011 184.223 52.8366 184.243 52.7765C184.263 52.7164 184.299 52.6632 184.348 52.6231C184.397 52.583 184.457 52.5576 184.519 52.5499C184.582 52.5422 184.646 52.5525 184.703 52.5797C184.76 52.6068 184.809 52.6496 184.842 52.7032C184.876 52.7567 184.894 52.8187 184.894 52.882ZM184.894 54.096C184.894 54.162 184.875 54.2266 184.838 54.2814C184.801 54.3363 184.749 54.379 184.688 54.404C184.622 54.4315 184.549 54.4369 184.479 54.4195C184.409 54.4021 184.347 54.3628 184.302 54.3074C184.256 54.252 184.23 54.1834 184.226 54.1119C184.223 54.0403 184.243 53.9694 184.282 53.9098C184.322 53.8503 184.38 53.8051 184.448 53.781C184.515 53.7569 184.589 53.7551 184.657 53.776C184.726 53.7969 184.786 53.8393 184.829 53.8969C184.871 53.9545 184.894 54.0243 184.894 54.096ZM139.195 52.679C145.259 52.4555 151.329 52.4555 157.393 52.679C151.329 52.9024 145.259 52.9024 139.195 52.679ZM139.195 54.31C143.419 54.1999 147.645 54.1999 151.869 54.31C147.784 54.42 143.288 54.416 139.195 54.31ZM145.219 59.916C154.598 59.813 165.12 59.813 174.496 59.916C165.12 60.02 154.598 60.02 145.219 59.916Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.953 77.3361C144.251 77.2761 152.553 77.2901 160.851 77.2661C169.149 77.2431 177.451 77.2661 185.752 77.3361C177.451 77.3931 169.153 77.3801 160.851 77.4031C152.549 77.4261 144.251 77.3931 135.953 77.3361ZM135.953 82.9301C144.251 82.8731 152.553 82.8861 160.851 82.8631C169.149 82.8401 177.451 82.8631 185.752 82.9301C177.451 82.9901 169.153 82.9761 160.851 83.0001C152.549 83.0231 144.251 83.0031 135.953 82.9301ZM135.953 88.5531C144.251 88.4961 152.553 88.5101 160.851 88.4861C169.149 88.4631 177.451 88.4861 185.752 88.5531C177.451 88.6131 169.153 88.6001 160.851 88.6231C152.549 88.6461 144.251 88.6001 135.953 88.5531ZM135.953 94.1631C144.251 94.1061 152.553 94.1191 160.851 94.0961C169.149 94.0731 177.451 94.0961 185.752 94.1631C177.451 94.2231 169.153 94.2061 160.851 94.2331C152.553 94.2061 144.251 94.2231 135.953 94.1631ZM135.953 99.7731C144.251 99.7131 152.553 99.7291 160.851 99.7061C169.149 99.6831 177.451 99.7061 185.752 99.7731C177.451 99.8331 169.153 99.8161 160.851 99.8431C152.553 99.8161 144.251 99.8331 135.953 99.7731Z",
    fill: "#455A64"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.982 73.688C146.055 78.931 146.035 84.17 146.069 89.413C146.039 94.653 146.069 99.896 145.982 105.136C145.908 99.896 145.928 94.653 145.898 89.414C145.928 84.17 145.908 78.927 145.982 73.688ZM154.599 73.688C154.672 78.931 154.652 84.17 154.686 89.413C154.652 94.653 154.686 99.896 154.599 105.136C154.526 99.896 154.546 94.653 154.516 89.414C154.546 84.17 154.512 78.927 154.599 73.688ZM163.204 73.688C163.277 78.931 163.257 84.17 163.287 89.413C163.257 94.653 163.287 99.896 163.204 105.136C163.131 99.896 163.151 94.653 163.117 89.414C163.151 84.17 163.131 78.927 163.204 73.688ZM171.821 73.688C171.894 78.931 171.874 84.17 171.904 89.413C171.874 94.653 171.904 99.896 171.821 105.136C171.748 99.896 171.764 94.653 171.734 89.414C171.768 84.17 171.748 78.927 171.821 73.688ZM180.438 73.688C180.512 78.931 180.492 84.17 180.522 89.413C180.492 94.653 180.522 99.896 180.438 105.136C180.365 99.896 180.382 94.653 180.352 89.414C180.382 84.17 180.365 78.927 180.438 73.688Z",
    fill: "#455A64"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.219 95.7041C138.74 95.7041 139.647 90.0071 141.798 90.0071C143.949 90.0071 144.179 94.1631 145.991 94.1631C147.802 94.1631 147.748 86.8621 150.183 86.8621C152.618 86.8621 152.054 89.8241 154.602 89.8241C157.15 89.8241 156.183 82.9301 158.851 82.9301C161.52 82.9301 160.439 92.4081 163.214 92.4081C164.972 92.4081 165.649 89.4071 167.747 89.4071C169.134 89.4071 169.951 90.9111 171.766 90.9111C173.58 90.9111 173.977 85.1211 176.245 85.1211C178.513 85.1211 178.77 88.5461 180.437 88.5461C182.105 88.5461 182.702 82.9361 185.774 82.9361V105.129H137.219V95.7041Z",
    fill: "#FB6A1F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M137.219 95.7041C138.74 95.7041 139.647 90.0071 141.798 90.0071C143.949 90.0071 144.179 94.1631 145.991 94.1631C147.802 94.1631 147.748 86.8621 150.183 86.8621C152.618 86.8621 152.054 89.8241 154.602 89.8241C157.15 89.8241 156.183 82.9301 158.851 82.9301C161.52 82.9301 160.439 92.4081 163.214 92.4081C164.972 92.4081 165.649 89.4071 167.747 89.4071C169.134 89.4071 169.951 90.9111 171.766 90.9111C173.58 90.9111 173.977 85.1211 176.245 85.1211C178.513 85.1211 178.77 88.5461 180.437 88.5461C182.105 88.5461 182.702 82.9361 185.774 82.9361V105.129H137.219V95.7041Z",
    fill: "#FB6A1F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.219 95.9769V95.4299C137.679 95.4299 138.313 94.0959 138.776 93.1289C139.57 91.4609 140.394 89.7339 141.798 89.7339C143.132 89.7339 143.816 90.9979 144.406 92.1119C144.87 92.9859 145.347 93.8889 145.991 93.8889C146.558 93.8889 147.048 92.1349 147.408 90.8539C147.995 88.7559 148.602 86.5879 150.183 86.5879C151.594 86.5879 152.147 87.4379 152.634 88.1889C153.121 88.9389 153.518 89.5499 154.602 89.5499C155.583 89.5499 155.966 87.9419 156.337 86.3879C156.774 84.5599 157.224 82.6689 158.851 82.6689C160.479 82.6689 160.879 85.0509 161.316 87.5719C161.67 89.6099 162.107 92.1479 163.214 92.1479C163.881 92.1479 164.415 91.5209 164.988 90.8609C165.682 90.0539 166.473 89.1369 167.747 89.1369C168.51 89.1369 169.107 89.5099 169.684 89.8739C170.261 90.2369 170.915 90.6439 171.766 90.6439C172.396 90.6439 172.97 89.2669 173.433 88.1589C174.1 86.5349 174.811 84.8539 176.248 84.8539C177.686 84.8539 178.376 85.9479 178.997 86.9119C179.45 87.6159 179.877 88.2789 180.441 88.2789C180.921 88.2789 181.461 87.2149 181.942 86.2789C182.759 84.6709 183.776 82.6729 185.767 82.6729V83.2229C184.233 83.2229 183.352 84.9569 182.572 86.4849C181.905 87.7949 181.378 88.8199 180.441 88.8199C179.503 88.8199 178.943 88.0099 178.393 87.1519C177.843 86.2949 177.259 85.3939 176.248 85.3939C175.301 85.3939 174.654 86.9519 174.08 88.3259C173.44 89.8569 172.89 91.1809 171.769 91.1809C170.648 91.1809 169.935 90.7109 169.271 90.2969C168.741 89.9639 168.27 89.6769 167.75 89.6769C166.833 89.6769 166.182 90.4309 165.549 91.1639C164.915 91.8979 164.235 92.6849 163.214 92.6849C161.516 92.6849 161.089 90.2339 160.639 87.6389C160.306 85.6649 159.872 83.2089 158.851 83.2089C157.831 83.2089 157.371 84.9469 157.007 86.4819C156.563 88.3359 156.146 90.0869 154.602 90.0869C153.058 90.0869 152.534 89.2099 152.031 88.4189C151.577 87.7189 151.18 87.1119 150.183 87.1119C149.186 87.1119 148.552 89.2399 148.072 90.9539C147.531 92.8849 147.101 94.4129 145.991 94.4129C144.88 94.4129 144.356 93.3889 143.779 92.3019C143.246 91.3019 142.695 90.257 141.798 90.257C140.901 90.257 140.06 91.945 139.413 93.299C138.706 94.806 138.149 95.9769 137.219 95.9769Z",
    fill: "#FB6A1F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M163.213 92.4221V105.136H154.602V89.8241C157.15 89.8241 156.182 82.9301 158.851 82.9301C161.519 82.9301 160.438 92.4221 163.213 92.4221Z",
    fill: "#FB6A1F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.849 84.13C159.028 84.13 159.205 84.0947 159.371 84.0261C159.536 83.9576 159.687 83.8571 159.813 83.7305C159.94 83.6038 160.041 83.4534 160.109 83.288C160.178 83.1225 160.213 82.9451 160.213 82.766C160.213 82.5869 160.178 82.4095 160.109 82.244C160.041 82.0785 159.94 81.9281 159.813 81.8015C159.687 81.6748 159.536 81.5744 159.371 81.5058C159.205 81.4373 159.028 81.402 158.849 81.402C158.487 81.402 158.14 81.5457 157.885 81.8015C157.629 82.0573 157.485 82.4042 157.485 82.766C157.485 83.1277 157.629 83.4747 157.885 83.7305C158.14 83.9863 158.487 84.13 158.849 84.13Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.623 82.7661C159.624 82.9209 159.579 83.0725 159.494 83.2016C159.408 83.3307 159.286 83.4313 159.143 83.4906C159 83.5498 158.842 83.5651 158.691 83.5344C158.539 83.5036 158.4 83.4283 158.291 83.3181C158.159 83.169 158.088 82.9749 158.094 82.7756C158.1 82.5762 158.182 82.3866 158.323 82.2456C158.464 82.1046 158.653 82.0228 158.853 82.0169C159.052 82.0111 159.246 82.0816 159.395 82.2141C159.541 82.3606 159.623 82.5591 159.623 82.7661ZM161.301 77.2061H156.352V79.9681H161.301V77.2061ZM158.172 79.9681H159.476L158.826 80.9051L158.172 79.9681Z",
    fill: "#FB6A1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M157.273 78.227C158.318 78.1703 159.364 78.1703 160.409 78.227C159.364 78.2803 158.318 78.2803 157.273 78.227ZM157.273 78.76C158.318 78.7033 159.364 78.7033 160.409 78.76C159.364 78.8151 158.318 78.8151 157.273 78.76Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M137.215 74.028C137.271 79.214 137.318 84.398 137.322 89.583L137.375 105.136L137.215 105.009L161.486 105.039L173.623 105.066L185.76 105.136L173.623 105.206L161.486 105.233L137.215 105.266H137.055V105.136L137.108 89.584C137.111 84.397 137.168 79.214 137.215 74.028Z",
    fill: "#455A64"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M139.812 107.464C140.959 107.291 142.124 107.291 143.271 107.464C142.125 107.634 140.959 107.634 139.812 107.464ZM133.57 77.336C134.081 77.1627 134.634 77.1627 135.145 77.336C134.634 77.506 134.081 77.506 133.57 77.336ZM133.57 82.93C134.081 82.7599 134.634 82.7599 135.145 82.93C134.634 83.1034 134.081 83.1034 133.57 82.93ZM133.57 88.553C134.081 88.3828 134.634 88.3828 135.145 88.553C134.634 88.7264 134.081 88.7264 133.57 88.553ZM133.57 94.163C134.081 93.9928 134.634 93.9928 135.145 94.163C134.634 94.3364 134.081 94.3364 133.57 94.163ZM133.57 99.773C134.081 99.6012 134.634 99.6012 135.145 99.773C134.634 99.9449 134.081 99.9449 133.57 99.773ZM148.297 107.464C149.442 107.291 150.607 107.291 151.752 107.464C150.607 107.634 149.442 107.634 148.297 107.464ZM156.781 107.464C157.928 107.291 159.093 107.291 160.24 107.464C159.093 107.634 157.928 107.634 156.781 107.464ZM165.266 107.464C166.412 107.291 167.578 107.291 168.724 107.464C167.578 107.634 166.412 107.634 165.266 107.464ZM173.742 107.464C174.889 107.291 176.054 107.291 177.201 107.464C176.054 107.634 174.889 107.634 173.742 107.464ZM182.227 107.464C183.373 107.291 184.539 107.291 185.685 107.464C184.539 107.634 183.373 107.634 182.227 107.464ZM133.602 68.638C138.484 68.411 143.404 68.411 148.277 68.638C143.391 68.865 138.471 68.865 133.602 68.638ZM133.602 70.182C136.738 69.9518 139.888 69.9518 143.024 70.182C139.887 70.4088 136.739 70.4088 133.602 70.182Z",
    fill: "#DBDBDB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.336 70.1819C179.474 70.0119 182.62 70.0119 185.758 70.1819C182.62 70.3486 179.474 70.3486 176.336 70.1819Z",
    fill: "#FB6A1F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M133.938 112.614C138.874 112.387 143.853 112.387 148.793 112.614C143.85 112.841 138.874 112.841 133.938 112.614Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M174.547 112.614C178.285 112.447 182.029 112.447 185.767 112.614C182.029 112.783 178.289 112.783 174.547 112.614Z",
    fill: "#FB6A1F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M144.047 117.283C147.935 117.055 151.832 117.055 155.72 117.283C151.832 117.509 147.935 117.509 144.047 117.283ZM144.047 118.994C147.307 118.767 150.579 118.767 153.839 118.994C150.579 119.221 147.307 119.221 144.047 118.994Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.758 124.494C185.641 124.38 133.7 124.827 133.821 124.494V115.255H133.947L159.846 115.282C168.494 115.302 177.143 115.282 185.794 115.335C185.794 115.365 185.744 124.447 185.758 124.484V124.494ZM185.758 124.494L185.721 115.382C177.319 115.535 168.414 115.412 159.846 115.469C159.962 115.379 133.337 115.712 134.057 115.382V124.494C133.35 124.184 185.928 124.591 185.771 124.494H185.758Z",
    fill: "#DBDBDB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.893 116.693H135.289V123.297H141.893V116.693Z",
    fill: "#FB6A1F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M184.252 119.995C184.252 120.871 183.904 121.711 183.285 122.33C182.666 122.949 181.826 123.297 180.95 123.297C180.074 123.297 179.234 122.949 178.615 122.33C177.996 121.711 177.648 120.871 177.648 119.995C177.648 119.119 177.996 118.279 178.615 117.66C179.234 117.041 180.074 116.693 180.95 116.693C181.826 116.693 182.666 117.041 183.285 117.66C183.904 118.279 184.252 119.119 184.252 119.995Z",
    fill: "#455A64"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M183.81 118.354L180.945 119.995V116.693C181.527 116.693 182.098 116.846 182.601 117.138C183.104 117.43 183.521 117.849 183.81 118.354Z",
    fill: "#FB6A1F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.941 122.279C181.547 122.279 182.128 122.039 182.556 121.611C182.985 121.183 183.226 120.602 183.226 119.996C183.226 119.39 182.986 118.809 182.558 118.381C182.13 117.952 181.549 117.711 180.943 117.711C180.643 117.711 180.346 117.77 180.069 117.884C179.792 117.999 179.54 118.167 179.328 118.379C179.116 118.591 178.947 118.843 178.832 119.12C178.717 119.397 178.658 119.694 178.658 119.994C178.658 120.294 178.717 120.591 178.831 120.868C178.946 121.145 179.114 121.397 179.326 121.609C179.538 121.821 179.79 121.99 180.067 122.105C180.344 122.22 180.641 122.279 180.941 122.279Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.047 128.993C147.935 128.767 151.832 128.767 155.72 128.993C151.832 129.22 147.935 129.22 144.047 128.993ZM144.047 130.711C147.307 130.484 150.579 130.484 153.839 130.711C150.579 130.938 147.307 130.938 144.047 130.711Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M185.758 136.211C185.641 136.097 133.7 136.544 133.821 136.211V126.972H133.947L159.859 127.009C168.507 127.029 177.156 127.009 185.808 127.062C185.808 127.092 185.758 136.174 185.771 136.211H185.758ZM185.758 136.211L185.721 127.099C177.319 127.252 168.414 127.129 159.846 127.186C159.962 127.095 133.337 127.429 134.057 127.099V136.211C133.35 135.901 185.928 136.308 185.771 136.211H185.758Z",
    fill: "#DBDBDB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.893 128.41H135.289V135.014H141.893V128.41ZM184.252 131.712C184.252 132.588 183.904 133.428 183.285 134.047C182.666 134.666 181.826 135.014 180.95 135.014C180.074 135.014 179.234 134.666 178.615 134.047C177.996 133.428 177.648 132.588 177.648 131.712C177.648 130.836 177.996 129.996 178.615 129.377C179.234 128.758 180.074 128.41 180.95 128.41C181.826 128.41 182.666 128.758 183.285 129.377C183.904 129.996 184.252 130.836 184.252 131.712Z",
    fill: "#455A64"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M184.247 131.712C184.247 131.873 184.235 132.035 184.211 132.195L180.945 131.712V128.41C181.821 128.41 182.661 128.758 183.28 129.377C183.899 129.996 184.247 130.836 184.247 131.712Z",
    fill: "#FB6A1F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M183.226 131.711C183.226 132.049 183.151 132.383 183.007 132.689C182.863 132.994 182.653 133.264 182.392 133.479C182.131 133.693 181.825 133.848 181.497 133.93C181.17 134.013 180.828 134.021 180.496 133.956C180.165 133.89 179.852 133.751 179.581 133.55C179.31 133.348 179.086 133.089 178.927 132.791C178.768 132.493 178.677 132.163 178.66 131.826C178.643 131.488 178.702 131.151 178.831 130.839C179.004 130.421 179.297 130.064 179.674 129.814C180.113 129.52 180.64 129.388 181.166 129.44C181.692 129.492 182.183 129.725 182.556 130.099C182.984 130.527 183.225 131.107 183.226 131.711Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.047 140.71C147.935 140.484 151.832 140.484 155.72 140.71C151.832 140.937 147.935 140.937 144.047 140.71ZM144.047 142.428C147.307 142.201 150.579 142.201 153.839 142.428C150.579 142.655 147.307 142.655 144.047 142.428Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M185.758 147.928C185.641 147.814 133.7 148.261 133.821 147.928V138.689H133.947L159.859 138.726C168.507 138.746 177.156 138.726 185.808 138.779C185.808 138.809 185.758 147.891 185.771 147.928H185.758ZM185.758 147.928L185.721 138.816C177.319 138.969 168.414 138.846 159.846 138.902C159.962 138.812 133.337 139.146 134.057 138.816V147.928C133.35 147.617 185.928 148.024 185.771 147.928H185.758Z",
    fill: "#DBDBDB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.893 140.126H135.289V146.73H141.893V140.126Z",
    fill: "#FB6A1F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M184.252 143.428C184.253 144.096 184.051 144.748 183.673 145.299C183.295 145.849 182.758 146.272 182.134 146.51C181.583 146.723 180.984 146.783 180.402 146.686C179.819 146.588 179.273 146.336 178.821 145.955C178.369 145.574 178.028 145.079 177.833 144.521C177.638 143.963 177.596 143.363 177.712 142.784C177.873 141.981 178.326 141.266 178.984 140.778C179.642 140.29 180.458 140.065 181.274 140.145C182.089 140.225 182.845 140.606 183.396 141.212C183.946 141.819 184.251 142.609 184.252 143.428Z",
    fill: "#455A64"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M184.247 143.428C184.248 144.096 184.046 144.748 183.668 145.299C183.29 145.849 182.753 146.272 182.129 146.51L180.945 143.428V140.126C181.821 140.126 182.661 140.474 183.28 141.093C183.899 141.712 184.247 142.552 184.247 143.428Z",
    fill: "#FB6A1F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M183.226 143.428C183.226 143.88 183.092 144.322 182.842 144.698C182.591 145.074 182.234 145.368 181.817 145.542C181.399 145.715 180.94 145.76 180.496 145.672C180.053 145.584 179.645 145.366 179.325 145.047C179.006 144.727 178.789 144.319 178.701 143.876C178.613 143.433 178.658 142.974 178.831 142.556C179.004 142.138 179.297 141.781 179.674 141.531C180.113 141.237 180.64 141.105 181.166 141.157C181.692 141.209 182.183 141.442 182.556 141.816C182.984 142.244 183.225 142.824 183.226 143.428Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M64.544 57.468H13.41C12.5678 57.4684 11.734 57.6347 10.9561 57.9573C10.1782 58.28 9.47143 58.7527 8.8762 59.3485C8.28098 59.9442 7.80893 60.6514 7.48701 61.4296C7.16509 62.2079 6.99961 63.0419 7 63.884V134.745C6.99961 135.587 7.16509 136.421 7.48701 137.199C7.80893 137.978 8.28098 138.685 8.8762 139.281C9.47143 139.876 10.1782 140.349 10.9561 140.672C11.734 140.994 12.5678 141.161 13.41 141.161H64.544C68.084 141.161 70.954 138.289 70.954 134.745V63.884C70.9544 63.0419 70.7889 62.2079 70.467 61.4296C70.1451 60.6514 69.673 59.9442 69.0778 59.3485C68.4826 58.7527 67.7758 58.28 66.9979 57.9573C66.22 57.6347 65.3862 57.4684 64.544 57.468Z",
    fill: "#FB6A1F",
    stroke: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.903 70.207V141.068C76.9035 142.337 76.528 143.578 75.8239 144.633C75.1198 145.689 74.1187 146.513 72.947 147C72.1691 147.323 71.3352 147.489 70.493 147.489H19.358C18.5158 147.488 17.682 147.321 16.9043 146.998C16.1266 146.675 15.4202 146.202 14.8254 145.605C14.2306 145.009 13.7591 144.301 13.4378 143.523C13.1166 142.744 12.9518 141.91 12.953 141.068V70.207C12.953 68.507 13.628 66.875 14.829 65.672C15.4235 65.0763 16.1296 64.6036 16.9069 64.2809C17.6841 63.9581 18.5174 63.7917 19.359 63.791H70.493C72.193 63.791 73.823 64.467 75.025 65.67C76.2275 66.8737 76.9029 68.5056 76.903 70.207Z",
    fill: "white",
    stroke: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.903 70.207V74H12.953V70.207C12.953 68.507 13.628 66.875 14.829 65.672C15.4235 65.0763 16.1296 64.6036 16.9069 64.2809C17.6841 63.9581 18.5174 63.7917 19.359 63.791H70.493C72.193 63.791 73.823 64.467 75.025 65.67C76.2275 66.8737 76.9029 68.5056 76.903 70.207Z",
    fill: "#FB6A1F",
    stroke: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.71 78.395H18.978V81.038H34.71V78.395ZM34.71 102.077H18.978V104.72H34.71V102.077ZM34.71 123.552H18.978V126.195H34.71V123.552Z",
    fill: "#FB6A1F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.661 84.938H18.977V86.876H63.66L63.661 84.938ZM55.604 88.643H18.977V90.532H55.604V88.643ZM60.4 92.289H18.977V94.178H60.4V92.289ZM60.4 95.93H18.977V97.82H60.4V95.93ZM63.661 106.413H18.977V108.351H63.66L63.661 106.413ZM55.604 110.118H18.977V112.007H55.604V110.118ZM60.4 113.764H18.977V115.653H60.4V113.764ZM63.661 129.993H18.977V131.931H63.66L63.661 129.993ZM55.604 133.703H18.977V135.592H55.604V133.703ZM60.4 137.349H18.977V139.238H60.4V137.349Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M153.195 20.654V49.294C153.195 50.299 152.997 51.294 152.612 52.223C152.033 53.6204 151.053 54.8147 149.796 55.6549C148.538 56.4951 147.059 56.9433 145.547 56.943H79.647C78.6429 56.9439 77.6484 56.7466 76.7206 56.3626C75.7928 55.9786 74.9498 55.4153 74.24 54.705C73.5297 53.9945 72.9663 53.1511 72.5819 52.2228C72.1976 51.2945 71.9998 50.2997 72 49.295V20.655C72.0008 18.6254 72.8068 16.679 74.241 15.243C75.6743 13.8081 77.6189 13.0013 79.647 13H145.547C147.576 13 149.521 13.806 150.955 15.242C152.389 16.678 153.195 18.6245 153.195 20.654Z",
    fill: "white",
    stroke: "#222221"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M153.195 20.654V21.31H72V20.654C72.0014 18.6251 72.8073 16.6796 74.241 15.244C75.6741 13.8088 77.6187 13.0016 79.647 13H145.547C147.576 13 149.521 13.806 150.955 15.242C152.389 16.678 153.195 18.6245 153.195 20.654Z",
    fill: "#FB6A1F",
    stroke: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M83.926 18.525C83.7206 18.7333 83.4447 18.8573 83.1525 18.8727C82.8603 18.8881 82.5729 18.7937 82.3467 18.6081C82.1206 18.4225 81.9719 18.1591 81.93 17.8695C81.888 17.58 81.9558 17.2852 82.12 17.043C82.2115 16.9081 82.3302 16.7937 82.4684 16.7071C82.6066 16.6206 82.7613 16.5638 82.9227 16.5405C83.084 16.5171 83.2485 16.5276 83.4056 16.5714C83.5627 16.6151 83.7089 16.6911 83.8349 16.7946C83.961 16.898 84.0641 17.0266 84.1377 17.1721C84.2112 17.3176 84.2537 17.4769 84.2622 17.6397C84.2708 17.8025 84.2453 17.9654 84.1874 18.1178C84.1295 18.2702 84.0405 18.4089 83.926 18.525ZM89.371 18.525C89.1656 18.7333 88.8897 18.8573 88.5975 18.8727C88.3053 18.8881 88.0179 18.7937 87.7917 18.6081C87.5656 18.4225 87.4169 18.1591 87.375 17.8695C87.333 17.58 87.4008 17.2852 87.565 17.043C87.6565 16.9081 87.7752 16.7937 87.9134 16.7071C88.0516 16.6206 88.2063 16.5638 88.3677 16.5405C88.529 16.5171 88.6935 16.5276 88.8506 16.5714C89.0077 16.6151 89.1539 16.6911 89.2799 16.7946C89.406 16.898 89.5091 17.0266 89.5827 17.1721C89.6562 17.3176 89.6987 17.4769 89.7072 17.6397C89.7158 17.8025 89.6903 17.9654 89.6324 18.1178C89.5745 18.2702 89.4855 18.4089 89.371 18.525ZM94.801 18.525C94.5956 18.7333 94.3197 18.8573 94.0275 18.8727C93.7353 18.8881 93.4479 18.7937 93.2217 18.6081C92.9956 18.4225 92.8469 18.1591 92.805 17.8695C92.763 17.58 92.8308 17.2852 92.995 17.043C93.0915 16.8988 93.2188 16.7778 93.3677 16.6886C93.5166 16.5995 93.6834 16.5445 93.8562 16.5276C94.0289 16.5106 94.2032 16.5322 94.3666 16.5907C94.5299 16.6493 94.6783 16.7433 94.801 16.866C95.0196 17.0869 95.1423 17.3852 95.1423 17.696C95.1423 18.0068 95.0196 18.3041 94.801 18.525Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.704 26.576H77.164V49.5391H103.704V26.576Z",
    stroke: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.349 26.576H107.805V28.191H138.349V26.576ZM131.235 29.9191H107.805V31.529H131.235V29.9191ZM142.691 33.2471H107.805V34.877H142.691V33.2471ZM137.513 36.4911H107.805V38.121H137.513V36.4911Z",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M125.13 56H110.193C109.773 56.0001 109.358 56.0829 108.971 56.2436C108.583 56.4043 108.231 56.6398 107.934 56.9366C107.638 57.2334 107.403 57.5856 107.242 57.9733C107.082 58.361 107 58.7765 107 59.196V67.971C107 68.3905 107.082 68.806 107.242 69.1937C107.403 69.5814 107.638 69.9336 107.934 70.2304C108.231 70.5272 108.583 70.7627 108.971 70.9234C109.358 71.0841 109.773 71.1669 110.193 71.167H125.13C125.55 71.1669 125.965 71.0841 126.352 70.9234C126.74 70.7627 127.092 70.5272 127.389 70.2304C127.685 69.9336 127.92 69.5814 128.081 69.1937C128.241 68.806 128.323 68.3905 128.323 67.971V59.196C128.323 58.7765 128.241 58.361 128.081 57.9733C127.92 57.5856 127.685 57.2334 127.389 56.9366C127.092 56.6398 126.74 56.4043 126.352 56.2436C125.965 56.0829 125.55 56.0001 125.13 56Z",
    fill: "white",
    stroke: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M113.876 60.561L109.773 63.135L113.582 66.512M121.348 66.757L125.035 63.615L120.781 60.825M115.875 68.695L118.902 59.191",
    stroke: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M89.494 181.805C89.494 181.805 75.314 185.872 73.334 186.577C71.535 187.213 66.656 188.926 62.994 188.393C62.6402 188.342 62.2904 188.266 61.947 188.167C58.236 187.061 56.569 186.029 56.08 183.694C55.59 181.36 57.439 179.637 59.219 178.536C60.999 177.435 70.65 176.285 70.65 176.285L72.983 176.97L89.494 181.805Z",
    fill: "#FB6A1F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M62.993 188.393C62.6396 188.342 62.2901 188.266 61.947 188.167C58.236 187.061 56.569 186.029 56.08 183.694C55.59 181.36 57.439 179.637 59.219 178.536C60.999 177.435 70.65 176.285 70.65 176.285L72.983 176.97C70.87 177.949 63.008 178.482 61.292 179.471C59.576 180.459 58.749 182.319 59.762 184.854C60.304 186.176 61.752 187.473 62.993 188.393Z",
    fill: "#FFBF9D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M87.367 182.383C87.367 182.383 76.717 185.143 72.493 186.91C68.269 188.676 60.216 189.45 57.336 185.808C54.456 182.167 57.004 179.025 59.874 178.325C62.744 177.626 68.548 176.524 71.716 176.97",
    stroke: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.203 188.202C63.203 188.202 57.786 185.226 59.585 181.056C60.915 177.983 68.141 178.649 71.721 176.97",
    stroke: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M132.698 189.053C132.551 190.521 132.037 191.897 130.571 192.763C129.593 193.34 128.204 193.683 126.214 193.663C121.241 193.6 111.893 190.042 111.893 190.042L103.141 185.197L107.693 177.988L108.94 176.03L112.157 176.754C112.157 176.754 114.822 178.267 117.501 179.471C120.18 180.675 126.688 180.939 128.981 182.784C131.275 184.629 132.947 186.636 132.698 189.053Z",
    fill: "#FB6A1F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M132.692 189.053C132.546 190.521 132.032 191.897 130.565 192.763C130.988 191.32 130.902 189.775 130.321 188.388C129.343 186.19 126.16 184.252 121.975 183.929C117.789 183.606 114.587 181.649 112.909 180.772C111.599 180.092 108.837 178.604 107.688 177.988L108.934 176.03L112.152 176.754C112.152 176.754 114.816 178.267 117.496 179.471C120.175 180.675 126.683 180.939 128.976 182.784C131.269 184.629 132.942 186.636 132.692 189.053Z",
    fill: "#FFBF9D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M105.066 186.557C111.365 190.222 118.328 192.603 125.553 193.561C127.147 193.752 129 193.781 130.066 192.582C130.349 192.235 130.56 191.835 130.686 191.406C130.812 190.976 130.851 190.526 130.799 190.081C130.608 187.83 128.716 186.048 126.643 185.153C124.57 184.257 122.286 184.052 120.081 183.557C117.888 183.062 115.768 182.286 113.774 181.247C112.19 180.42 110.659 179.417 108.914 179.045C107.168 178.673 105.09 179.123 104.156 180.65",
    stroke: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M129.482 193.194C130.301 192.801 131.018 192.222 131.574 191.503C132.129 190.784 132.51 189.945 132.684 189.053C133.002 186.934 131.794 184.8 130.098 183.499C128.401 182.197 126.274 181.58 124.176 181.145C122.079 180.709 119.932 180.415 117.923 179.618C114.857 178.414 111.831 176.045 108.633 176.892",
    stroke: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M114.938 110.738L100.128 105.1L99.942 105.027C99.942 105.027 99.996 104.635 100.04 104.048C100.133 102.864 100.182 100.936 99.624 100.285C98.798 99.3051 96.461 100.128 94.177 99.0811C91.894 98.0331 87.674 99.9081 87.674 99.9081C87.674 99.9081 84.624 99.3451 83.274 101.547C82.589 103.324 82.824 105.952 82.824 105.952L82.545 106.05C80.78 106.711 71.177 110.327 69.148 111.781C66.904 113.371 64.42 129.703 63.623 134.499C62.826 139.295 61.408 143.617 62.127 145.266C62.846 146.915 73.162 154.868 79.098 156.919C85.034 158.969 106.083 158.387 106.083 158.387C106.083 158.387 106.426 158.294 107.037 158.098C110.596 156.953 123.226 152.225 129.929 141.126C129.939 141.145 123.446 119.841 114.938 110.738ZM74.923 138.209C73.833 138.982 74.433 141.977 74.433 141.977L72.581 140.343L77.235 128.886L79.221 137.695C79.221 137.695 76.013 137.44 74.923 138.209ZM112.161 145.486C111.647 145.751 113.628 140.245 112.689 138.997C111.75 137.749 108.919 137.866 108.919 137.866L109.159 136.364L110.836 127.75L111.393 127.089C111.393 127.089 117.153 136.971 118.185 140.455C118.185 140.465 111.907 145.486 112.161 145.486Z",
    fill: "#FB6A1F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M86.99 75.007L79.342 83.131C79.342 83.131 78.291 84.066 78.707 86.42C79.122 88.774 80.1 90.824 80.838 90.961C81.4225 91.0635 82.0146 91.116 82.608 91.118C82.608 91.118 84.246 94.671 85.41 96.066C85.41 96.066 85.811 101.552 85.596 103.074C85.596 103.074 88.344 105.477 90.93 105.781C93.517 106.084 97.511 102.12 97.511 102.12L98.489 97.265C98.489 97.265 100.836 93.702 100.993 92.753C101.149 91.803 102.225 92.048 102.753 91.578C103.281 91.108 104.499 89.018 104.709 87.041C104.919 85.064 104.924 82.793 102.631 83.459C100.641 82.925 101.888 78.716 101.888 78.716L98.392 75.633L86.99 75.007Z",
    fill: "#FFBF9D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100.127 105.1C100.012 105.403 99.8798 105.698 99.731 105.986C98.47 108.365 92.974 112.902 92.974 112.902L91.312 107.787L90.402 112.902C88.569 112.099 82.975 107.249 82.975 107.249C82.975 107.249 82.785 106.794 82.555 106.084L82.833 105.986C82.833 105.986 82.599 103.339 83.283 101.582C84.623 99.379 87.683 99.942 87.683 99.942C87.683 99.942 91.903 98.068 94.187 99.115C96.47 100.162 98.807 99.35 99.634 100.319C100.46 101.288 99.951 105.047 99.951 105.047L100.127 105.1Z",
    fill: "#FFBF9D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.951 110.738L100.141 105.1L99.955 105.027C99.955 105.027 100.009 104.636 100.053 104.048L99.745 105.972L97.555 108.947C99.8965 109.81 102.183 110.817 104.4 111.962C105.462 112.531 106.329 113.407 106.887 114.475C107.445 115.543 107.669 116.755 107.529 117.952L104.801 141.321L103.681 154.589L107.06 158.098C110.619 156.953 123.249 152.225 129.952 141.126C129.952 141.145 123.459 119.841 114.951 110.738ZM112.174 145.486C111.661 145.751 113.641 140.245 112.702 138.997C111.764 137.749 108.933 137.866 108.933 137.866L109.172 136.364L110.849 127.75L111.407 127.09C111.407 127.09 117.166 136.971 118.198 140.455C118.198 140.465 111.92 145.486 112.174 145.486ZM80.218 138.997L77.915 131.293C77.915 131.293 73.783 117.194 70.952 113.719L71.695 123.634C71.695 123.634 69.251 135.478 67.016 138.997C64.781 142.515 64.283 143.401 67.016 143.401C69.749 143.401 76.404 148.706 76.404 148.706L75.89 144.302L80.218 138.997ZM74.414 141.977L72.561 140.342L77.215 128.885L79.201 137.695C79.201 137.695 76.013 137.455 74.922 138.223C73.832 138.992 74.414 141.977 74.414 141.977Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M85.39 96.066C85.39 96.066 85.812 100.221 85.39 102.12M97.922 101.562C97.926 100.226 98.081 98.895 98.382 97.593",
    stroke: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M99.037 78.105C99.037 78.105 101.55 81.261 101.418 83.65C101.286 86.038 101.1 88.867 101.164 91.637C101.227 94.407 96.719 100.211 94.401 100.725C92.084 101.239 90.089 101.371 88.607 99.888C87.126 98.405 85.644 96.345 83.717 93.702C81.792 91.059 82.251 85.26 82.251 85.26",
    stroke: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M92.99 87.467C92.8367 88.3343 92.7711 89.2147 92.794 90.095C92.744 90.837 92.974 91.571 93.439 92.151C93.719 92.435 94.119 92.665 94.173 93.056C94.1716 93.2324 94.1226 93.405 94.0313 93.5559C93.94 93.7067 93.8096 93.8301 93.654 93.913C93.3406 94.0713 93.0386 94.2511 92.75 94.451M89.016 94.754C89.016 94.754 89.304 96.629 91.812 97.02",
    stroke: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M89.257 88.896C89.257 89.439 89.023 89.875 88.734 89.875C88.446 89.875 88.211 89.439 88.211 88.896C88.211 88.353 88.446 87.917 88.734 87.917C89.023 87.917 89.257 88.356 89.257 88.896ZM96.757 89.131C96.757 89.674 96.523 90.11 96.234 90.11C95.946 90.11 95.711 89.67 95.711 89.131C95.711 88.593 95.946 88.152 96.234 88.152C96.523 88.152 96.757 88.588 96.757 89.132V89.131Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.242 86.757C95.242 86.757 97.687 84.31 99.736 87.041M90.097 86.806C90.097 86.806 88.552 85.074 86.117 86.806M82.606 90.962C82.606 90.962 80.62 91.662 80.092 90.115C79.564 88.568 77.755 84.492 79.339 83.131C80.924 81.771 82.195 84.927 82.195 84.927M101.172 91.803C101.172 91.803 103.015 92.175 103.543 90.629C104.071 89.082 105.88 85.005 104.296 83.645C102.712 82.285 101.441 85.441 101.441 85.441",
    stroke: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.19 88.896C82.8799 88.7871 83.5025 88.4195 83.931 87.868C84.1931 87.3843 84.3595 86.8547 84.421 86.308C84.601 85.266 84.693 84.212 84.694 83.155C84.6724 82.7424 84.7101 82.3289 84.806 81.927C84.953 81.522 85.179 81.151 85.471 80.836C86.161 80.023 86.997 79.338 87.657 78.496C88.0108 78.0987 88.28 77.6334 88.4482 77.1287C88.6163 76.6239 88.6799 76.0902 88.635 75.56C90.1474 76.8079 91.9149 77.7091 93.8131 78.2003C95.7114 78.6915 97.6942 78.7607 99.622 78.403C103.118 77.718 106.467 74.649 106.061 70.793C105.985 70.1465 105.708 69.5401 105.27 69.059C104.831 68.5779 104.253 68.2464 103.616 68.111C101.89 67.681 100.34 68.601 98.776 69.193C95.926 70.269 93.133 68.419 90.253 68.111C87.809 67.841 84.763 68.151 83.481 70.602C83.481 70.602 79.081 71.121 77.125 74.762C75.169 78.403 78.871 83.439 78.871 83.439C78.871 83.439 80.338 81.639 82.259 85.279L82.19 88.896Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M99.34 77.1751C99.34 77.1751 98.196 83.1451 101.184 86.0381C101.184 86.0381 101.839 84.2421 102.499 83.8011C102.974 82.7414 103.176 81.5791 103.084 80.4212C102.993 79.2633 102.612 78.147 101.976 77.1751C99.766 73.7001 99.34 77.1751 99.34 77.1751Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.789 70.382C104.527 71.1963 104.083 71.9401 103.489 72.5567C102.896 73.1733 102.171 73.6464 101.367 73.94C97.22 75.633 93.197 73.759 89.04 73.392C85.652 73.089 81.911 76.152 81.672 79.637M79.11 78.716C79.1611 77.3416 79.6019 76.0101 80.3809 74.8768C81.16 73.7435 82.2452 72.855 83.51 72.315",
    stroke: "#FFBF9D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M84.445 101.562C86.2684 103.464 88.4687 104.964 90.905 105.967C90.905 105.967 95.867 104.523 98.39 101.073",
    stroke: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M85.41 99.922C84.9649 100.039 84.5479 100.245 84.184 100.526C83.8201 100.808 83.5167 101.16 83.292 101.562C82.515 102.932 82.984 107.244 82.984 107.244C82.984 107.244 86.999 111.218 90.416 112.897L91.423 107.224L92.988 112.897C92.988 112.897 98.278 109.153 99.745 105.986C99.745 105.986 100.234 102.291 99.745 101.092C99.6336 100.759 99.4221 100.469 99.1394 100.262C98.8567 100.054 98.5167 99.9388 98.166 99.932M79.11 137.871C79.11 137.871 77.54 127.349 75.453 123.057M70.945 113.719C72.1609 115.448 73.2463 117.265 74.192 119.156M112.172 121.574C112.593 119.815 113.171 118.097 113.898 116.44M108.938 137.871C108.938 137.871 110.067 130.657 111.416 124.716M110.852 127.74C111.943 126.292 113.478 125.24 115.223 124.745",
    stroke: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M99.953 105.027C99.953 105.027 109.062 108.673 114.944 110.743C114.944 110.743 122.181 117.551 129.94 141.145C129.94 141.145 122.831 153.116 109.307 156.953",
    stroke: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M111.648 145.912L118.186 140.465C118.186 140.465 121.643 137.837 125.236 139.633",
    stroke: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M111.406 127.089C111.406 127.089 116.809 135.081 118.193 140.465M74.48 142.281L72.569 140.465C72.569 140.465 69.733 139.976 66.516 142.124M72.578 140.465C72.578 140.465 74.954 132.635 77.296 128.626",
    stroke: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M82.839 105.986C82.839 105.986 69.73 110.91 68.444 112.349C67.158 113.787 62.274 141.317 62.141 144.468C62.029 147.287 72.238 153.615 77.299 156.283",
    stroke: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.653 115.29C92.653 115.461 92.6022 115.629 92.507 115.771C92.4119 115.914 92.2766 116.025 92.1184 116.09C91.9602 116.156 91.786 116.173 91.618 116.139C91.4501 116.106 91.2958 116.023 91.1746 115.902C91.0535 115.781 90.9711 115.627 90.9376 115.459C90.9042 115.291 90.9214 115.117 90.9869 114.959C91.0525 114.8 91.1635 114.665 91.3059 114.57C91.4483 114.475 91.6157 114.424 91.787 114.424C91.901 114.423 92.014 114.445 92.1195 114.488C92.225 114.531 92.3208 114.595 92.4014 114.676C92.482 114.756 92.5458 114.852 92.589 114.957C92.6322 115.063 92.6539 115.176 92.653 115.29ZM107.822 161.402H77.996C77.8104 161.402 77.6323 161.328 77.501 161.197C77.3697 161.066 77.296 160.888 77.296 160.702C77.296 160.516 77.3697 160.338 77.501 160.207C77.6323 160.076 77.8104 160.002 77.996 160.002H107.822C108.008 160.002 108.186 160.076 108.317 160.207C108.448 160.338 108.522 160.516 108.522 160.702C108.522 160.888 108.448 161.066 108.317 161.197C108.186 161.328 108.008 161.402 107.822 161.402Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M108.857 159.062L112.851 140.269C112.913 139.978 112.909 139.676 112.839 139.387C112.77 139.098 112.636 138.827 112.449 138.596C112.262 138.365 112.025 138.178 111.756 138.05C111.488 137.922 111.194 137.856 110.896 137.856H76.034C75.5889 137.856 75.1567 138.006 74.8059 138.28C74.4552 138.554 74.206 138.937 74.098 139.369C74.0267 139.656 74.0199 139.955 74.078 140.245L77.662 158.411C77.7496 158.857 77.9868 159.26 78.3345 159.553C78.6822 159.846 79.1195 160.011 79.574 160.022L106.852 160.648C107.319 160.659 107.774 160.506 108.141 160.217C108.507 159.927 108.76 159.519 108.857 159.062Z",
    fill: "#FFBF9D",
    stroke: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M96.197 151.128C95.899 151.664 95.577 151.946 95.105 152.336L94.578 151.817C94.9849 151.557 95.3188 151.197 95.548 150.772C95.8761 150.181 95.9888 149.495 95.867 148.83L96.433 148.079C96.5864 148.494 96.662 148.934 96.656 149.376C96.6523 149.989 96.4951 150.592 96.197 151.128ZM96.117 147.44C95.847 146.991 95.516 146.611 95.067 146.319L94.547 146.857C94.96 147.126 95.343 147.493 95.563 147.968L95.567 147.977L96.117 147.44Z",
    fill: "#4C5256"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7 146.092C94.137 145.805 93.535 145.645 92.903 145.666C92.2706 145.687 91.6537 145.867 91.11 146.191C90.5692 146.513 90.1197 146.968 89.804 147.513C89.3286 148.334 89.1915 149.308 89.4219 150.229C89.6522 151.15 90.2318 151.944 91.038 152.445C91.573 152.781 92.185 152.975 92.818 153.011C93.4795 153.035 94.1354 152.882 94.718 152.568L94.183 152.029C93.7663 152.211 93.3133 152.295 92.859 152.274C92.3544 152.246 91.8652 152.09 91.437 151.822C91.0104 151.555 90.6593 151.183 90.417 150.742C90.1757 150.302 90.052 149.808 90.0578 149.307C90.0635 148.805 90.1986 148.314 90.45 147.88C90.7026 147.444 91.0623 147.081 91.495 146.823C91.9293 146.565 92.4219 146.42 92.927 146.403C93.43 146.403 93.697 146.442 94.145 146.635L94.7 146.092Z",
    fill: "#21AAE9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M90.867 148.018H91.564L92.71 151.002H92.013L90.867 148.018Z",
    fill: "#21AAE9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M93.726 148.018H93.02L91.86 151.002H92.565L93.726 148.018ZM91.796 148.018H91.551L91.539 148.024L91.675 148.381L91.694 148.375C91.6775 148.329 91.6781 148.279 91.6957 148.233C91.7134 148.188 91.7468 148.15 91.79 148.127C91.903 148.059 91.841 148.026 91.796 148.018ZM93.975 148.018H93.739L93.727 148.024L93.863 148.381L93.881 148.375C93.8645 148.329 93.8651 148.279 93.8827 148.233C93.9004 148.188 93.9338 148.15 93.977 148.127C94.084 148.063 94.036 148.03 93.992 148.019L93.975 148.018Z",
    fill: "#21AAE9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M92.239 149.789C92.285 149.837 92.318 149.809 92.329 149.789L92.34 149.792L92.285 149.934L92.219 149.792L92.239 149.789ZM93.047 148.018H93.747L94.283 149.461L93.948 150.395L93.047 148.018ZM92.675 150.726C92.653 150.818 92.686 150.861 92.706 150.871L92.696 150.905L92.609 150.814L92.641 150.71L92.675 150.726ZM91.886 150.686C91.909 150.805 91.883 150.875 91.859 150.881L91.874 150.905L91.956 150.805L91.927 150.693L91.886 150.686Z",
    fill: "#21AAE9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M93.438 149.109C93.365 148.984 93.308 149.057 93.288 149.109H93.234L93.36 148.745L93.501 149.109H93.438ZM90.751 148.116C90.864 148.146 90.963 148.305 90.999 148.381H91.011L90.871 148.018H90.713C90.623 148.052 90.701 148.098 90.751 148.116ZM91.79 150.903C91.903 150.873 92.002 150.714 92.038 150.638H92.05L91.91 151.002H91.762C91.7558 151.002 91.7496 151.001 91.744 150.998C91.667 150.964 91.742 150.921 91.79 150.903ZM92.8 150.903C92.686 150.873 92.587 150.714 92.552 150.638H92.539L92.68 151.002H92.828C92.8339 151.002 92.8397 151.001 92.845 150.998C92.922 150.964 92.849 150.921 92.8 150.903ZM93.954 150.903C94.067 150.873 94.166 150.714 94.202 150.638H94.214L94.074 151.002H93.926C93.9198 151.002 93.9135 151.001 93.908 150.998C93.831 150.964 93.906 150.921 93.954 150.903ZM95.002 150.903C94.89 150.873 94.79 150.714 94.755 150.638H94.742L94.883 151.002H95.031C95.0369 151.002 95.0427 151.001 95.048 150.998C95.125 150.964 95.051 150.921 95.002 150.903ZM92.77 148.018H93.006L93.018 148.024L92.882 148.381L92.864 148.375C92.8805 148.329 92.8799 148.279 92.8623 148.233C92.8446 148.188 92.8112 148.15 92.768 148.127C92.661 148.063 92.709 148.03 92.753 148.019L92.77 148.018Z",
    fill: "#21AAE9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M94.919 150.953H94.07V151.002H94.919V150.953Z",
    fill: "#21AAE9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M94.043 150.788C94.0298 150.822 94.0105 150.853 93.986 150.88L93.961 150.924L94.075 150.977H94.878L94.885 150.943L94.878 150.855C94.931 149.561 96.519 147.567 97.306 146.732C95.248 148.174 94.273 150.037 94.043 150.788Z",
    fill: "#21AAE9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M101.602 139.653H105.743M81.828 139.653H97.548",
    stroke: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M108.922 179.016L105.744 187.365C105.744 187.365 97.638 185.319 87.257 183.19C76.397 180.963 65.059 178.081 59.177 167.749C58.463 166.492 57.984 165.004 58.321 163.594C59.167 160.027 63.807 159.058 66.863 158.7C68.7841 158.492 70.7147 158.384 72.647 158.377C73.625 158.377 76.877 157.844 77.664 158.426C78.8467 159.29 80.109 160.039 81.434 160.663C83.17 161.402 108.507 160.002 108.507 160.002C108.948 159.04 109.217 158.008 109.304 156.953C113.289 154.927 122.505 153.214 126.417 153.973C132.543 155.162 136.118 158.739 135.438 162.488C134.758 166.237 121.224 176.29 108.922 179.016Z",
    fill: "#073570"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M108.923 179.016C108.923 179.016 101.213 176.97 94.915 172.712C88.617 168.454 83.698 163.511 74.922 164.534",
    stroke: "#FFBF9D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M93.477 171.709C97.457 170.563 100.376 167.984 103.568 165.513C106.935 162.808 110.552 160.428 114.369 158.407",
    stroke: "#FFBF9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 150.5,
    r: 7.5,
    fill: "#FFBF9D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 146,
    width: 1,
    height: 2
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1923 146.829H96.9999V147.692H96.1923V146.829Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 146,
    width: 1,
    height: 2
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6921 146.872C96.6507 146.861 96.6088 146.858 96.5662 146.861C96.5236 146.864 96.4825 146.874 96.443 146.891C96.4038 146.907 96.368 146.93 96.3355 146.958C96.303 146.986 96.2761 147.018 96.254 147.055C96.2479 147.069 96.2402 147.081 96.2338 147.094C96.2231 147.116 96.2154 147.138 96.2108 147.162C96.2044 147.188 96.2007 147.213 96.1991 147.24C96.1979 147.266 96.1991 147.292 96.2031 147.318C96.2068 147.344 96.2129 147.37 96.2218 147.394C96.2307 147.419 96.2417 147.443 96.2552 147.465C96.2684 147.488 96.284 147.509 96.3015 147.528C96.3189 147.548 96.3382 147.565 96.3591 147.581C96.3802 147.597 96.4023 147.61 96.4259 147.622C96.4495 147.633 96.474 147.642 96.4994 147.648C96.5401 147.658 96.5812 147.662 96.6232 147.659C96.6648 147.655 96.7053 147.646 96.7442 147.63C96.7828 147.614 96.8183 147.593 96.8508 147.566C96.883 147.539 96.9105 147.508 96.9329 147.473L96.9623 147.414H96.9639C96.9715 147.395 96.9779 147.376 96.9822 147.356C96.9884 147.331 96.992 147.305 96.9933 147.279C96.9945 147.253 96.993 147.227 96.989 147.201C96.985 147.174 96.9786 147.149 96.9697 147.125C96.9608 147.1 96.9498 147.076 96.9363 147.054C96.9228 147.031 96.9072 147.011 96.8897 146.991C96.8723 146.972 96.8529 146.954 96.8321 146.939C96.8113 146.923 96.7889 146.909 96.7653 146.898C96.742 146.887 96.7175 146.878 96.6921 146.872Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_36_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2307 146.698L96.0392 147.628L96.9617 147.82L97.1529 146.891L96.2307 146.698Z",
    fill: "url(#paint0_linear_36_344)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 150,
    width: 1,
    height: 2
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1139 150.907H96.9767V151.77H96.1139V150.907Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_36_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 150,
    width: 1,
    height: 2
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6643 150.955C96.6227 150.944 96.5807 150.941 96.5381 150.944C96.4955 150.947 96.4545 150.957 96.4152 150.974C96.3757 150.99 96.3399 151.013 96.3074 151.04C96.2752 151.069 96.248 151.101 96.2259 151.138L96.2045 151.177C96.195 151.199 96.1873 151.222 96.1812 151.245C96.1695 151.291 96.1662 151.338 96.1711 151.386C96.1763 151.434 96.1891 151.479 96.2103 151.521C96.2314 151.564 96.259 151.602 96.2936 151.635C96.3282 151.668 96.3671 151.694 96.4109 151.712C96.4548 151.731 96.5001 151.742 96.5476 151.744C96.5951 151.746 96.6413 151.74 96.6867 151.726C96.732 151.711 96.7734 151.69 96.8111 151.661C96.8484 151.631 96.88 151.596 96.9051 151.556C96.9159 151.537 96.925 151.517 96.9342 151.498H96.9358C96.9434 151.479 96.9483 151.461 96.9545 151.441C96.9606 151.415 96.9643 151.389 96.9655 151.363C96.9667 151.337 96.9655 151.311 96.9615 151.285C96.9575 151.259 96.9511 151.233 96.9425 151.208C96.9336 151.184 96.9223 151.16 96.9088 151.138C96.8953 151.115 96.88 151.094 96.8622 151.074C96.8448 151.055 96.8255 151.037 96.8046 151.022C96.7835 151.006 96.7614 150.993 96.7375 150.981C96.714 150.97 96.6894 150.961 96.6643 150.955Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_36_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.199 150.781L96.0072 151.713L96.9339 151.906L97.1257 150.974L96.199 150.781Z",
    fill: "#2771E0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 145,
    width: 7,
    height: 9
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M89 145H95.8786V153.471H89V145Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_36_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 144,
    width: 7,
    height: 10
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5039 151.958C95.4485 151.946 95.393 151.947 95.3376 151.959C95.2821 151.971 95.2316 151.994 95.1859 152.028C95.0312 152.139 94.8682 152.236 94.6973 152.319C94.5263 152.403 94.3495 152.471 94.1669 152.524C93.9847 152.578 93.799 152.615 93.6103 152.637C93.4215 152.659 93.2322 152.665 93.0423 152.655L92.9883 152.652C92.8327 152.642 92.6783 152.62 92.5254 152.589C90.6844 152.205 89.5021 150.392 89.8833 148.541C90.2644 146.69 92.0655 145.498 93.905 145.882C94.3557 145.975 94.7702 146.154 95.1489 146.416H95.1504C95.1731 146.438 95.1976 146.456 95.2245 146.471C95.2607 146.49 95.2987 146.504 95.3388 146.513C95.3832 146.522 95.428 146.523 95.473 146.517C95.518 146.51 95.5609 146.497 95.6014 146.476C95.6418 146.456 95.678 146.429 95.7092 146.396C95.7408 146.362 95.7662 146.325 95.7852 146.284C95.8039 146.242 95.8158 146.199 95.8201 146.153C95.8244 146.108 95.8213 146.063 95.8106 146.018C95.8002 145.974 95.7824 145.932 95.7579 145.894C95.7334 145.855 95.7031 145.822 95.6675 145.794H95.666L95.6397 145.775L95.6335 145.771C95.1587 145.434 94.6372 145.207 94.0686 145.089C91.7938 144.615 89.5671 146.086 89.0947 148.377C88.6225 150.667 90.0855 152.907 92.3618 153.382C92.644 153.441 92.9292 153.471 93.2175 153.471C93.5061 153.471 93.7913 153.441 94.0735 153.382C94.3557 153.323 94.6289 153.235 94.8933 153.119C95.1577 153.003 95.4074 152.862 95.6427 152.694L95.6504 152.689L95.6675 152.676L95.6752 152.671C95.7493 152.61 95.7968 152.532 95.8171 152.438C95.8226 152.412 95.8253 152.385 95.8253 152.359C95.8256 152.332 95.8232 152.306 95.8183 152.279C95.8131 152.253 95.8057 152.228 95.7956 152.203C95.7858 152.179 95.7736 152.155 95.7589 152.133C95.7445 152.111 95.7279 152.09 95.7092 152.071C95.6908 152.052 95.6706 152.035 95.6486 152.02C95.6268 152.005 95.6035 151.992 95.5793 151.982C95.5548 151.971 95.5297 151.964 95.5039 151.958Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_36_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.2807 143.636L87.3288 153.122L95.545 154.835L97.4969 145.348L89.2807 143.636Z",
    fill: "url(#paint1_linear_36_344)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 146,
    width: 6,
    height: 6
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2119 146.594H90.5844V151.77H95.2119V146.594Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_36_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 146,
    width: 6,
    height: 6
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8715 151.652C93.661 151.711 93.4463 151.742 93.2278 151.746C93.0091 151.749 92.7937 151.724 92.5814 151.671L92.4919 151.646H92.4904C92.4435 151.632 92.3969 151.617 92.351 151.601C92.305 151.585 92.2597 151.567 92.2147 151.548C92.1696 151.53 92.1252 151.509 92.0814 151.488C92.0373 151.467 91.9941 151.444 91.9515 151.42C91.9089 151.396 91.8672 151.371 91.8262 151.344C91.7848 151.318 91.7447 151.291 91.7049 151.262C91.6653 151.233 91.6267 151.203 91.5887 151.172C91.5511 151.142 91.514 151.11 91.4781 151.077C91.442 151.043 91.4071 151.009 91.3727 150.974C91.3387 150.939 91.3057 150.903 91.2738 150.866C91.2416 150.829 91.2107 150.791 91.181 150.752C91.1509 150.714 91.1221 150.674 91.0946 150.634C91.067 150.593 91.0406 150.552 91.0152 150.51C90.9901 150.468 90.9659 150.425 90.9432 150.382C90.9205 150.339 90.8988 150.295 90.8786 150.25C90.8583 150.205 90.8393 150.16 90.8216 150.115C90.8038 150.069 90.7873 150.023 90.7723 149.976C90.7572 149.929 90.7435 149.882 90.7309 149.835C90.7186 149.787 90.7076 149.74 90.6978 149.691C90.6883 149.643 90.68 149.595 90.673 149.547C90.6659 149.498 90.6604 149.449 90.6565 149.4C90.6522 149.351 90.6494 149.302 90.6482 149.253C90.6469 149.204 90.6469 149.155 90.6485 149.106C90.6497 149.057 90.6528 149.008 90.6571 148.959C90.661 148.911 90.6669 148.862 90.6739 148.813C90.681 148.765 90.6892 148.716 90.699 148.668C90.7088 148.62 90.7202 148.572 90.7324 148.525C90.745 148.478 90.7588 148.43 90.7741 148.384C90.7894 148.337 90.806 148.291 90.8237 148.245C90.8415 148.2 90.8605 148.155 90.881 148.11C90.9015 148.066 90.923 148.021 90.946 147.978C90.9689 147.935 90.9931 147.892 91.0186 147.85C91.0437 147.809 91.0704 147.767 91.0979 147.727C91.1258 147.687 91.1546 147.647 91.1846 147.608C91.2143 147.57 91.2456 147.532 91.2778 147.495C91.3096 147.458 91.343 147.422 91.377 147.387C91.4113 147.352 91.4463 147.318 91.4824 147.285C91.5186 147.252 91.5556 147.22 91.5936 147.189C91.6316 147.158 91.6702 147.129 91.7097 147.1C91.7496 147.072 91.79 147.044 91.8311 147.018C91.8724 146.992 91.9141 146.967 91.957 146.943C91.9996 146.919 92.0428 146.896 92.0866 146.875C92.1307 146.854 92.1751 146.834 92.2202 146.815C92.2652 146.796 92.3109 146.779 92.3568 146.763C92.4028 146.746 92.4493 146.732 92.4962 146.718C92.5431 146.705 92.5903 146.693 92.6381 146.682C92.6855 146.671 92.7333 146.662 92.7814 146.654C92.8295 146.646 92.8779 146.639 92.9263 146.635C92.9748 146.629 93.0235 146.625 93.0722 146.623C93.1209 146.621 93.1696 146.62 93.2183 146.62C93.267 146.621 93.3157 146.623 93.3645 146.626C93.4132 146.629 93.4616 146.634 93.51 146.64C93.5584 146.646 93.6065 146.654 93.6546 146.663C93.7024 146.672 93.7502 146.682 93.7974 146.693C93.8449 146.705 93.892 146.718 93.9386 146.732C93.9852 146.747 94.0314 146.762 94.0771 146.779C94.1227 146.796 94.1681 146.815 94.2128 146.834C94.2572 146.854 94.3013 146.875 94.3449 146.897C94.3883 146.919 94.4312 146.943 94.4735 146.968C94.5155 146.992 94.5569 147.018 94.5976 147.045C94.6383 147.072 94.6782 147.1 94.7174 147.13C94.7563 147.159 94.7946 147.189 94.832 147.221C94.8691 147.252 94.9055 147.285 94.941 147.319C94.9766 147.353 95.0109 147.387 95.0446 147.423L95.1108 147.498C95.1197 147.509 95.1273 147.521 95.1341 147.533C95.1598 147.578 95.1769 147.627 95.1855 147.678C95.1938 147.73 95.1932 147.781 95.1834 147.832C95.1736 147.883 95.1552 147.931 95.1282 147.976C95.1013 148.02 95.0673 148.059 95.0268 148.091C94.9861 148.123 94.941 148.147 94.8917 148.163C94.8424 148.18 94.7918 148.186 94.7401 148.184C94.6883 148.182 94.6387 148.17 94.5909 148.15C94.5431 148.13 94.5005 148.102 94.4628 148.066L94.4227 148.021C94.3534 147.947 94.2781 147.879 94.1969 147.819C94.1157 147.758 94.0296 147.705 93.9389 147.66C93.8482 147.615 93.7545 147.578 93.657 147.551C93.5599 147.522 93.461 147.503 93.3605 147.493C93.2597 147.483 93.1589 147.482 93.0581 147.49C92.9573 147.498 92.858 147.515 92.7603 147.542C92.6626 147.568 92.5679 147.602 92.4763 147.646C92.3847 147.689 92.2977 147.74 92.2153 147.799C92.1329 147.858 92.0563 147.924 91.9858 147.996C91.915 148.069 91.8513 148.148 91.7949 148.232C91.7382 148.316 91.6895 148.405 91.6488 148.498C91.608 148.591 91.5759 148.688 91.5523 148.786C91.5287 148.885 91.514 148.986 91.5085 149.087C91.5026 149.189 91.506 149.29 91.5186 149.391C91.5308 149.492 91.5523 149.591 91.5823 149.688C91.6126 149.786 91.6512 149.879 91.6981 149.969C91.745 150.06 91.7995 150.145 91.8614 150.225C91.9236 150.305 91.9922 150.38 92.0676 150.448C92.143 150.515 92.2238 150.576 92.3099 150.629C92.3963 150.682 92.4864 150.727 92.5808 150.764C92.6748 150.801 92.7716 150.829 92.8709 150.849C92.9702 150.868 93.0703 150.879 93.1715 150.88C93.2725 150.881 93.373 150.873 93.4729 150.856C93.5725 150.839 93.6699 150.814 93.7652 150.779C93.9757 150.703 94.1635 150.589 94.3283 150.437C94.3298 150.437 94.3298 150.437 94.3298 150.436L94.3654 150.403C94.3847 150.387 94.4052 150.372 94.4273 150.358C94.4717 150.332 94.5192 150.314 94.5697 150.305C94.6203 150.296 94.6711 150.296 94.7217 150.305C94.7725 150.315 94.82 150.332 94.8641 150.359C94.9086 150.385 94.9469 150.418 94.9793 150.458C95.0118 150.499 95.0363 150.543 95.0529 150.592C95.0694 150.641 95.0771 150.692 95.0759 150.744C95.0743 150.795 95.0642 150.845 95.0449 150.893C95.0256 150.941 94.9989 150.985 94.9643 151.023C94.9496 151.041 94.9331 151.057 94.9147 151.071H94.9132C94.6126 151.349 94.2655 151.543 93.8715 151.652Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_36_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5443 147.735L94.2048 144.732L97.2964 150.633L91.6358 153.636L88.5443 147.735Z",
    fill: "url(#paint2_linear_36_344)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 148,
    width: 4,
    height: 2
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5258 148.397H92.1533V149.966H95.5258V148.397Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_36_344)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_36_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 148,
    width: 4,
    height: 2
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1969 149.078C92.2024 149.036 92.2116 148.995 92.2242 148.954C92.2367 148.913 92.2527 148.874 92.2717 148.836C92.2909 148.798 92.313 148.762 92.3384 148.728C92.3636 148.694 92.3914 148.662 92.4221 148.633C92.4527 148.603 92.4855 148.577 92.5204 148.553C92.5553 148.529 92.5921 148.508 92.6307 148.491C92.6693 148.473 92.7088 148.459 92.7499 148.448C92.7906 148.437 92.8323 148.43 92.8743 148.426C92.9166 148.422 92.9585 148.422 93.0008 148.425C93.0431 148.428 93.0845 148.435 93.1255 148.446C93.1666 148.456 93.2064 148.47 93.245 148.487C93.2839 148.504 93.3207 148.525 93.3562 148.548C93.3914 148.572 93.4245 148.598 93.4555 148.627C93.4861 148.656 93.5143 148.688 93.54 148.722C93.5658 148.755 93.5881 148.791 93.6077 148.829C93.6273 148.867 93.6436 148.906 93.6567 148.946C93.8047 149.03 94.0085 149.081 94.2355 149.081C94.4297 149.081 94.609 149.043 94.7493 148.979C94.7851 148.917 94.8338 148.869 94.896 148.834C94.9264 148.817 94.9588 148.803 94.9931 148.794C95.0134 148.789 95.0342 148.786 95.055 148.785C95.1123 148.779 95.1681 148.786 95.2226 148.805C95.2771 148.824 95.3249 148.853 95.3666 148.893H95.3681L95.3975 148.926C95.4132 148.944 95.4267 148.963 95.4377 148.984C95.4506 149.007 95.4613 149.03 95.4692 149.055C95.4775 149.08 95.4833 149.106 95.4867 149.132C95.4898 149.158 95.4907 149.185 95.4885 149.211C95.4867 149.237 95.4824 149.263 95.4754 149.288C95.4683 149.314 95.4591 149.338 95.4472 149.362C95.4355 149.385 95.4218 149.407 95.4055 149.428C95.3896 149.449 95.3715 149.468 95.3519 149.485C95.332 149.502 95.3105 149.517 95.2879 149.53C95.2156 149.571 95.1377 149.588 95.055 149.58C95.0339 149.578 95.0134 149.574 94.9931 149.569C94.9288 149.553 94.8724 149.522 94.8234 149.477L94.7787 149.429C94.7787 149.428 94.7781 149.428 94.7771 149.428L94.7493 149.386C94.609 149.321 94.4297 149.282 94.2355 149.282C94.0085 149.282 93.8047 149.333 93.6567 149.418C93.6417 149.462 93.6231 149.505 93.6004 149.546C93.5777 149.586 93.5517 149.624 93.5219 149.66C93.4922 149.696 93.4595 149.729 93.4239 149.759C93.3881 149.788 93.3501 149.814 93.3096 149.837C93.2692 149.86 93.2269 149.878 93.1831 149.893C93.139 149.908 93.0943 149.919 93.0483 149.925C93.0023 149.932 92.9564 149.934 92.9101 149.932C92.8639 149.93 92.8182 149.924 92.7729 149.913C92.7278 149.902 92.684 149.888 92.6417 149.869C92.5992 149.851 92.5587 149.828 92.5204 149.802C92.4821 149.776 92.4466 149.746 92.4135 149.713C92.3807 149.681 92.351 149.645 92.3247 149.607C92.2983 149.568 92.2756 149.528 92.2566 149.485C92.2376 149.443 92.2226 149.399 92.2116 149.354C92.2009 149.308 92.1941 149.262 92.1917 149.216C92.1889 149.169 92.1908 149.123 92.1969 149.077V149.078Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_36_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.3547 147.762L95.7888 149.872L92.325 150.594L91.8905 148.484L95.3547 147.762Z",
    fill: "url(#paint3_linear_36_344)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_344",
    x1: 96.1351,
    y1: 147.163,
    x2: 97.0578,
    y2: 147.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#2B6ADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#2E66D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#3160D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#3260D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#335ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#355BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#355ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#3855CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3953CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3B4FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3C4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3D4CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#453EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#463DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#473CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4E2FB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4F2EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#4F2DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#502DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#502CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#512BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#512AAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#5229AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5228AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#5328AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#5327AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5327AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_344",
    x1: 90.82,
    y1: 143.124,
    x2: 94.8002,
    y2: 155.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#0092D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#0093D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#0094D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#0095D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0096D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#0097D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334773,
    stopColor: "#0098D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0098D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0099D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#009AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#009BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#009CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#009DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#009ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#009FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00A0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#00A1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00A1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#00A3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#00A4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00A5D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#00A5CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00A6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00A7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00A8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#00A9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#00AACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#00ABCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#00ACCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00AECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665227,
    stopColor: "#00AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#00B0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#00B2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#00B6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#00B9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00BACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00BEC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00BFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36_344",
    x1: 90.1034,
    y1: 150.98,
    x2: 95.8851,
    y2: 147.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0405615,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#00B6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#00B6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#00B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#00B6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#00B6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00B5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#00B5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#00B5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#00B5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#00B5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#00B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#00B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#00B5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00B4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#00B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#00B4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#00B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#00B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#00B3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#00B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#00B3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#00B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#00B3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#00B3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#00B2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#00B2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00B2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#00B2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#00B2D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#00B1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#00B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#00B1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#00B1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#00B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#00B1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#00B1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#00B0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#00B0CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#00B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959438,
    stopColor: "#00B0C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36_344",
    x1: 95.9307,
    y1: 150.561,
    x2: 92.4648,
    y2: 151.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#2771E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#2770DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#2870DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#286FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#296EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#296DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A6DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#2A6CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#2B6BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#2B6BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#2C6ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#2C69DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#2D68D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#2D67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#2E67D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2E66D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2E65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2F65D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2F64D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#3063D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#3062D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#3162D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#3161D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#3260D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#325FD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#335ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#335DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#345CD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#345BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523437,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#355AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3559CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3659CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3658CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#3657CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3757CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3756CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#3856CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3855CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3854CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3954CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3953CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#3A52CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#3A51CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#3B50C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#3B4FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3C4EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3D4DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3D4CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#3D4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3E4BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#3E4AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3F49C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#3F48C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4048C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4047C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4146C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#4145C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4145C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#4244C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#4243C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#4342C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#4342BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#4441BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#4440BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#453FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#453EBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#463DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#463CBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#473BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#473BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#483ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#4839B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4938B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#4938B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4A37B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#4A36B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4A35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#4B35B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#4B34B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#4C33B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#4C32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#4D32B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#4D31B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#4E30B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2FB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8.53333,
    fill: "white",
    transform: "translate(89 145)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDeployment);
export default __webpack_public_path__ + "static/media/web-deployment.42a56d6006357ed5b75e0ed10d29c0ef.svg";
export { ForwardRef as ReactComponent };